import { post2 } from "@/shared/axios";
import { AppsmenError } from "@/shared/utils/interfaces";
import { PaymentLedger } from "@/shared/utils/interfaces";
import { useMutation } from "@tanstack/react-query";

const useSessionPaymentLedgerSpecificPost = () => {
  const mutation = useMutation<
    PaymentLedger[],
    AppsmenError,
    { orderId: number; parts: string[] }
  >({
    mutationFn: ({ orderId, parts }) =>
      post2(
        `internal/secure/pos/v1/orders/session-orders-payment-ledger-specific-payments/${orderId}`,
        parts
      ),
  });

  return mutation;
};

export default useSessionPaymentLedgerSpecificPost;
